import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {DeferredElement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/deferred_element.types';
import {HubPageService_HeroBrandElementLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/hub_page/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useHubTypeFromSlug} from '../../../../../../backend-services/HubPage/utils/useHubTypeFromSlug';
import {useTargetGroupIdentifier} from '../../../../../../shared-deprecated/useTargetGroupIdentifier';
import {useReductionsStateRequestParameter} from '../../../../../ReductionsState/useReductionsStateRequestParameter';

export const useGetDeferredProducts = (deferred: DeferredElement) => {
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();
  const hubType = useHubTypeFromSlug();

  return useGrpcRequest(HubPageService_HeroBrandElementLazy, {
    session,
    targetGroup,
    hub: hubType,
    deferred,
    reductionsState,
  });
};
